import subclientsApi from './createApi/subclientsApi';

export const subclients = {
	getSubclientsPaginate: async function( pageUrl ) {
		try {
			const response = await subclientsApi.get( pageUrl );
			return response;
		} catch ( error ) {
			return error.response;
		}
	},
	getSubclientDetails: async function( subclientId ) {
		try {
			const response = await subclientsApi.get( `/sub-client?id=${subclientId}` );
			return response;
		} catch ( error ) {
			return error.response;
		}
	},
	getPaymentsType: async function ( typeForm = 'default' ) {
		return await subclientsApi.get( `/sub-client/get-payments-type?paymentTypeForm=${typeForm}` );
	},
	postNewSubclient: async function( payload ) {
		const response = await subclientsApi.post( '/sub-client', payload );
		return response;
	},
	editSubclient: async function( payload, subclientId ) {
		const response = await subclientsApi.put( `/sub-client/${subclientId}`, payload );
		return response;
	},
	updateSubclientStatus: async function( payload ) {
		try {
			const response = await subclientsApi.patch( '/sub-client/toggle-status', payload );
			return response;
		} catch ( error ) {
			return error.response;
		}
	},
	getWhatsappGroupList: async function() {
		const response = await subclientsApi.get( '/whatsapp-group-list' );
		return response;
	},
	getSubClientFormFields: async function( subClientId ) {
		const response = await subclientsApi.get( `/sub-client/${ subClientId }/form-fields` );
		return response;
	},
	editSubClientFormFields: async function( subClientId, formType, groupId, hasBeneficiaries, hasMultipleSignatures, payload ) {
		const response = await subclientsApi.put( `/sub-client/${ subClientId }/form-fields`, { ...payload, formType, groupId, hasBeneficiaries, hasMultipleSignatures } );
		return response;
	},
	updateSubClientFormFieldLabel: async function( subClientId, formType, groupId, payload ) {
		const response = await subclientsApi.put( `/sub-client/${subClientId}/form-fields/bulk`, { ...payload, formType, groupId } );
		return response;
	}
};

